import React from 'react';
import PropTypes from 'prop-types';

import { fulfillmentOptions } from 'constants/fulfillmentOptions';

import Box from '@mui/material/Box';
import CartDelivery from 'bento-ordering/cart/components/CartDelivery';
import CartPickup from 'bento-ordering/cart/components/CartPickup';
import CartDineIn from 'bento-ordering/cart/components/CartDineIn';

/**
 * Display cart details by fulfillment method
 */
class CartFulfillmentMethod extends React.PureComponent {
  static propTypes = {
    fulfillmentAddress: PropTypes.string.isRequired,
    changeFulfillment: PropTypes.func,
    fulfillmentTimeOrASAP: PropTypes.string,
    fulfillmentMethod: PropTypes.string.isRequired,
    restaurantName: PropTypes.string.isRequired
  };

  static defaultProps = {
    changeFulfillment: null,
    fulfillmentTimeOrASAP: 'ASAP'
  };

  getCartContent = () => {
    const {
      fulfillmentAddress,
      changeFulfillment,
      fulfillmentTimeOrASAP,
      fulfillmentMethod,
      restaurantName
    } = this.props;

    const cartProps = {
      fulfillmentAddress,
      changeFulfillment,
      fulfillmentTimeOrASAP,
      handleClick: changeFulfillment
    };

    switch (fulfillmentMethod) {
      case fulfillmentOptions.DELIVERY:
        return <CartDelivery {...cartProps} />;
      case fulfillmentOptions.DINE_IN:
        return <CartDineIn restaurantName={restaurantName} />;
      case fulfillmentOptions.PICKUP:
        return <CartPickup {...cartProps} />;
      default:
        return null;
    }
  };

  render() {
    return (
      <Box data-testid="cart-fulfillment-method" width="100%">
        {this.getCartContent()}
      </Box>
    );
  }
}

export default CartFulfillmentMethod;
